import React from "react";
import PropTypes from "prop-types";
import FadedScrollableText from "./FadedScrollableText";
import SanitizedText from "shared/components/SanitizedText";

import "apps/messenger/components/Connections/shared/Essay.scss";

function Essay({ title, clean_content: cleanContent }) {
	return (
		<div className="connection-scrollable-essay">
			<FadedScrollableText>
				<div className="connection-scrollable-essay-content">
					<div
						className="connection-scrollable-essay-content-title"
					>
						{title}
					</div>
					<SanitizedText
						className="connection-scrollable-essay-content-essay"
						text={cleanContent}
					/>
				</div>
			</FadedScrollableText>
		</div>
	);
}

Essay.propTypes = {
	title: PropTypes.string,
	clean_content: PropTypes.string,
};

Essay.defaultProps = {
	title: "",
	clean_content: "",
};

export default Essay;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/shared/Essay.jsx